// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"04adbe5d","213":"9e7ebe75","239":"0908715c","260":"adbef2ae","455":"6d4a7cac","596":"60199c8d","725":"3cf6d0bf"}[chunkId] + ".chunk.js";
};